import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { IconSetting, IconUpload } from '../Icon';
import { BasicModal } from './BasicModal';

interface Props {
  event: Immutable<RacemapEvent>;
  showStartTime: boolean;
  showDeltaTime: boolean;
  showOnline: boolean;
  onShowStartTimeChange: (arg0: boolean) => void;
  onShowDeltaTimeChange: (arg0: boolean) => void;
  onShowOnlineChange: (arg0: boolean) => void;
}

export const SettingsModal: FC<Props> = ({
  event,
  showStartTime,
  showDeltaTime,
  showOnline,
  onShowStartTimeChange,
  onShowDeltaTimeChange,
  onShowOnlineChange,
}) => {
  const netReplay = event.modules.netReplay.enabled;
  const visibleElements = event.modules.timing.visibleElements;
  const inRacemapApp = window.navigator.userAgent.includes('RacemapApp');
  const eventIsRunning = new Date(event.endTime).getTime() - Date.now() > 0;

  return (
    <BasicModal
      title="Settings:"
      buttonIcon={<IconSetting />}
      style={{ marginLeft: '5px', borderColor: '#ced4da' }}
    >
      <Row>
        <Col lg={6}>
          {visibleElements.stages && !netReplay && (
            <Form.Group className="mb-1" controlId="startTimeCheckbox">
              <Form.Check
                type="checkbox"
                label="Show Start Times"
                checked={showStartTime}
                onChange={(e) => {
                  onShowStartTimeChange(e.target.checked);
                }}
              />
            </Form.Group>
          )}
          {visibleElements.stages && (
            <Form.Group className="mb-1" controlId="deltaTimesCheckbox">
              <Form.Check
                type="checkbox"
                label="Show Delta Times"
                checked={showDeltaTime}
                onChange={(e) => {
                  onShowDeltaTimeChange(e.target.checked);
                }}
              />
            </Form.Group>
          )}
          {eventIsRunning && (
            <Form.Group className="mb-1" controlId="onlineParticipants">
              <Form.Check
                type="checkbox"
                label="Filter Online Participants"
                checked={showOnline}
                onChange={(e) => {
                  onShowOnlineChange(e.target.checked);
                }}
              />
            </Form.Group>
          )}
        </Col>
        <Col lg={12} style={{ paddingTop: '15px' }}>
          {!inRacemapApp && (
            <BasicModal
              buttonIcon={
                <div>
                  <IconUpload /> Upload Activity
                </div>
              }
            >
              <iframe width="100%" height="432" src={'/upload'} frameBorder="0" title="Upload" />
            </BasicModal>
          )}
        </Col>
      </Row>
    </BasicModal>
  );
};
